/* eslint-disable */
// @generated by protobuf-ts 2.9.3 with parameter eslint_disable,optimize_code_size
// @generated from protobuf file "Protobuf.proto" (syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class SyncRequest$Type extends MessageType {
    constructor() {
        super("SyncRequest", [
            {
                no: 1,
                name: "messages",
                kind: "message",
                repeat: 1 /*RepeatType.PACKED*/,
                T: () => EncryptedMessage,
            },
            { no: 2, name: "userId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "nodeId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "merkleTree", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
        ]);
    }
}
/** @generated MessageType for protobuf message SyncRequest */
export const SyncRequest = new SyncRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncResponse$Type extends MessageType {
    constructor() {
        super("SyncResponse", [
            {
                no: 1,
                name: "messages",
                kind: "message",
                repeat: 1 /*RepeatType.PACKED*/,
                T: () => EncryptedMessage,
            },
            { no: 2, name: "merkleTree", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
        ]);
    }
}
/** @generated MessageType for protobuf message SyncResponse */
export const SyncResponse = new SyncResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EncryptedMessage$Type extends MessageType {
    constructor() {
        super("EncryptedMessage", [
            { no: 1, name: "timestamp", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "content", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
        ]);
    }
}
/** @generated MessageType for protobuf message EncryptedMessage */
export const EncryptedMessage = new EncryptedMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageContent$Type extends MessageType {
    constructor() {
        super("MessageContent", [
            { no: 1, name: "table", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "row", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "column", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            {
                no: 4,
                name: "stringValue",
                kind: "scalar",
                oneof: "value",
                T: 9 /*ScalarType.STRING*/,
            },
            {
                no: 5,
                name: "numberValue",
                kind: "scalar",
                oneof: "value",
                T: 9 /*ScalarType.STRING*/,
            },
            {
                no: 6,
                name: "bytesValue",
                kind: "scalar",
                oneof: "value",
                T: 12 /*ScalarType.BYTES*/,
            },
            {
                no: 7,
                name: "jsonValue",
                kind: "scalar",
                oneof: "value",
                T: 9 /*ScalarType.STRING*/,
            },
        ]);
    }
}
/** @generated MessageType for protobuf message MessageContent */
export const MessageContent = new MessageContent$Type();
